import { Component } from 'react'
import css from './babylist-button-banner.scss'
import * as blUrls from 'lib/urls'
import classnames from 'classnames'
import Image from 'components/image'

class BabylistButtonBanner extends Component {
  state = {
    show: true,
  }

  render() {
    return this.state.show ? (
      <div
        className={classnames(
          css.buttonBanner,
          'hidden-xs hidden-sm pam mvxl clearfix'
        )}
      >
        <div className="pull-left mlxl mrl mts">
          <Image
            role="presentation"
            src="/assets/button-with-cursor.png"
            width="193"
          />
        </div>
        <div className="pull-left mvm">
          <small>
            <strong>Don't see what you're looking for?</strong>
          </small>
          <br />
          <small>
            <a href={blUrls.addItemsPath}>Install Babylist Button</a> to add
            items from any store.
          </small>
        </div>
      </div>
    ) : null
  }

  handleClickClose() {
    // TODO: actually persist
    this.setState({ show: false })
  }
}

export default BabylistButtonBanner
